import { useNavigate } from 'react-router-dom';
import { useSettings } from '../model/hooks';
import { emptyNull } from '../../../shared/misc';

// Limit number of redirection to fixed limit
// in case we fall into infinite loop
const LIMIT = 10;
let counter = 0;

const RedirectToEventsAirAuth = () => {
  const { eventsAirPageUrl } = useSettings() ?? emptyNull;
  const navigate = useNavigate();

  if (eventsAirPageUrl && counter < LIMIT) {
    counter += 1;
    // navigate(eventsAirPageUrl);
    console.log(window.location);

    window.location = window.location.origin + eventsAirPageUrl;
    // debugger;
  }

  return null;
};

export default RedirectToEventsAirAuth;
